import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

export const PriceMyRentalPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaMixin(
    'md',
    css`
      padding: 0;
    `,
  )};
`;

export const ContentSection = styled.section<{ noPaddingOrShadow?: boolean }>`
  width: 100%;
  max-width: 1280px;
  background: white;
  padding: 24px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  margin-bottom: 16px;

  ${mediaMixin(
    'md',
    css`
      padding: 32px;
      margin-bottom: 24px;
    `,
  )};

  ${({ noPaddingOrShadow }) =>
    noPaddingOrShadow &&
    `
        padding: 0 !important;
        box-shadow: none;
    `};
`;
